import { render } from "./GuestsTable.vue?vue&type=template&id=550d5baf"
import script from "./GuestsTable.vue?vue&type=script&lang=js"
export * from "./GuestsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__